module.exports = __webpack_public_path__ + "static/img/11-人大附中翠微学校.aa52e3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/11-人大附中翠微学校.png
// module id = XAhm
// module chunks = 0